import {
  SELLER_REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT,
  SELLER_REFERRAL_COOKIE_NAME,
} from "@/lib/seller-referral/constants"

const COOKIE_MAX_AGE_SECONDS = SELLER_REFERRAL_ATTRIBUTION_WINDOW_DAYS_DEFAULT * 24 * 60 * 60

const CODE_PATTERN = /^[A-Za-z0-9]{6,16}$/

export function normalizeSellerReferralCode(raw: string | null | undefined): string | null {
  if (!raw) return null
  const code = raw.trim().toUpperCase()
  if (!CODE_PATTERN.test(code)) return null
  return code
}

export function readSellerReferralCodeFromDocumentCookie(
  cookieHeader: string,
  name = SELLER_REFERRAL_COOKIE_NAME,
): string | null {
  if (!cookieHeader?.trim()) return null
  const prefix = `${name}=`
  for (const part of cookieHeader.split("; ")) {
    if (!part.startsWith(prefix)) continue
    try {
      const raw = decodeURIComponent(part.slice(prefix.length)).trim()
      return normalizeSellerReferralCode(raw)
    } catch {
      return null
    }
  }
  return null
}

export function buildSellerReferralCodeSetCookieValue(
  code: string,
  isSecure: boolean,
  maxAgeSeconds: number = COOKIE_MAX_AGE_SECONDS,
): string {
  const safe = code.trim().toUpperCase()
  return `${SELLER_REFERRAL_COOKIE_NAME}=${encodeURIComponent(safe)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${isSecure ? "; Secure" : ""}`
}
